<div id="invoice-amount" style="width: 100%; height: 400px"></div>
